import React from 'react';
import { connect } from 'react-redux';
import { bellOutline } from '@amzn/storm-ui-icons';
import { RootState } from 'src/app/store';
import {
  CommunicationsDrawerInfo,
  selectCommunicationsDrawerInfo,
} from '../../store/slice';
import { ErrorBoundary } from 'src/commons/components/ErrorBoundary';
import { MobileCommuCommunicationsDrawerPublisher } from 'src/commons/utils/metrics';
import { communicationsDrawerId } from './constants';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import UtilityButton from 'src/features/header/components/UtilityMenu/UtilityButton';

const COMMUNICATIONS_PATH = '/communications/feed?entityId=';

export const WrappedAcesCommunicationsDrawer: React.VFC<{
  communicationsDrawerInfo?: CommunicationsDrawerInfo;
}> = ({ communicationsDrawerInfo }) => {
  if (!communicationsDrawerInfo) {
    return null;
  }

  return (
    <ErrorBoundary name="aces-dynamic-communications-drawer-mobile">
      <UtilityButton
        icon={bellOutline}
        label={communicationsDrawerInfo.texts.label}
        onClick={() => {
          MobileCommuCommunicationsDrawerPublisher.publishCounterMonitor(
            'Open',
            1,
          );
          window.location.assign(
            `${COMMUNICATIONS_PATH}${communicationsDrawerInfo.texts.entityId}`,
          );
        }}
        {...getTaktAttributes(communicationsDrawerId, chromeComponents.HEADER)}
      />
    </ErrorBoundary>
  );
};
const acesConnector = connect((state: RootState) => {
  return {
    communicationsDrawerInfo: selectCommunicationsDrawerInfo(state),
  };
});

export const ConnectedWrappedAcesCommunicationsDrawer = acesConnector(
  WrappedAcesCommunicationsDrawer,
);
